import React, { FunctionComponent, useState } from 'react';
import { OffertType } from './../types';
import '../styles/components/summaryDetails.scss';
import ArrowDown from './Icons.tsx/ArrowDown';

interface DetailsProps {
  category: string;
  offert: OffertType;
}

const SummaryDetails: FunctionComponent<DetailsProps> = ({
  category,
  offert,
}: DetailsProps) => {
  const { rows, extras, base, price } = offert;
  const [hidden, setHidden] = useState<boolean>(true);

  return (
    <div className="summaryDetails">
      <div
        className={`summaryDetails_list ${hidden ? '' : 'summaryDetails_list--open'}`}
      >
        <div
          onClick={() => setHidden(!hidden)}
          className="summaryDetails_list--shadow shadow"
        >
          <ArrowDown />
        </div>
        {rows.map((row) => (
          <div className="summaryDetails_description" key={row.key}>
            <span className="summaryDetails_description_item">{row.text}</span>
            <span className="summaryDetails_description_price">
              {row.price?.toLocaleString('sv-SE')}kr
            </span>
          </div>
        ))}
        <div className="summaryDetails_description">
          <span className="summaryDetails_description_item">
            <b>Baspris</b>
          </span>
          <span className="summaryDetails_description_price">
            <b>{base.toLocaleString('sv-SE')}kr</b>
          </span>
        </div>
        {extras.map((row) => (
          <div key={row.key}>
            <div className="summaryDetails_description" key={row.key}>
              <span className="summaryDetails_description_item">
                Extra: {row.text}
              </span>
              <span className="summaryDetails_description_price">
                {(((row.multiplicator || 1) - 1) * base).toLocaleString(
                  'sv-SE'
                )}
                kr
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="summaryDetails_description summaryDetails_description--total">
        <span></span>
        <h3>
          Pris {category}
          {': '}
          {price.toLocaleString('sv-SE')}kr
        </h3>
      </div>
    </div>
  );
};

export default SummaryDetails;
